module.exports = {
    DATE: 'DATE',
    NUMBER: 'NUMBER',
}
